<div class="lookup-user-activities-wrap">
  <!-- Application History -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleApplicationHistoryPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showApplicationHistoryPanel">
        <span class="panel-title mb-0">Application History</span>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="showApplicationHistoryPanel"
          (click)="toggleApplicationHistoryPanel(); $event.stopPropagation()"
          aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="!showApplicationHistoryPanel"
          (click)="toggleApplicationHistoryPanel(); $event.stopPropagation()"
          aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body" *ngIf="showApplicationHistoryPanel">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <app-grid-actions
            [actions]="activitiesExportColumnChooserActions"
            [showColumnChooser]="showAppHistoryColumnChooser"
            [allColumns]="appHistoryAllColumns"
            [visibleColumns]="appHistoryVisibleColumns"
            (exportClick)="exportAppHistory()"
            (columnChooserToggle)="toggleAppHistoryColumnChooser()"
            (columnToggle)="onAppHistoryColumnToggle($event)"
            (columnChooserClose)="closeAppHistoryColumnChooser()">
          </app-grid-actions>
        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <ng-template #tplAppHistoryActions let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group"
                 *ngIf="data.date_submitted && data.date_submitted !== ''">
              <span class="action-span-wrapper">
                <button
                  type="button"
                  class="action-icon-button"
                  matTooltip="Resend Application Submission Email"
                  matTooltipPosition="above"
                  (click)="sendApplicationEmail(data); $event.stopPropagation()">
                  <img src="assets/images/message.svg" alt="" width="20" height="20" aria-hidden="true" />
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button
                  type="button"
                  class="action-icon-button"
                  matTooltip="Download"
                  matTooltipPosition="above"
                  (click)="downloadApplicationRow(data); $event.stopPropagation()">
                 <span class="material-symbols-outlined">download</span>
                </button>
              </span>
            </div>
          </ng-template>
          <app-data-grid #appHistoryGrid
            [config]="applicationHistoryGridConfig"
            [activeTab]="'default'"
            [onApplicationClick]="onLookupApplicationIdClick"
            [onCaseIdClick]="onLookupCaseIdClick"
            [actionsTemplateRef]="tplAppHistoryActions"
            [wordWrapEnabled]="false">
          </app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Nevada Testing + Supporting Documents -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleNevadaPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showNevadaPanel">
        <span class="panel-title mb-0">Nevada Praxis Testing</span>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="showNevadaPanel"
          (click)="toggleNevadaPanel(); $event.stopPropagation()"
          aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="!showNevadaPanel"
          (click)="toggleNevadaPanel(); $event.stopPropagation()"
          aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body" *ngIf="showNevadaPanel">
        <div *ngIf="!showAddTestForm" class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <app-grid-actions
            [actions]="activitiesExportColumnChooserActions"
            [showColumnChooser]="showNevadaTestingColumnChooser"
            [allColumns]="nevadaTestingAllColumns"
            [visibleColumns]="nevadaTestingVisibleColumns"
            (exportClick)="exportNevadaTesting()"
            (columnChooserToggle)="toggleNevadaTestingColumnChooser()"
            (columnToggle)="onNevadaTestingColumnToggle($event)"
            (columnChooserClose)="closeNevadaTestingColumnChooser()">
          </app-grid-actions>
          <button type="button" class="btn btn-primary btn-sm addpriporname ml-3" (click)="onAddTest()">
            <span class="material-symbols-outlined">add_circle</span> Add Test
          </button>
        </div>

        <!-- Inline Add Test Form -->
        <div *ngIf="showAddTestForm" class="activities-add-test-section px-2 pb-2" (click)="$event.stopPropagation()">
          <h6 class="activities-add-test-title mb-3 mt-0">Nevada Praxis Testing – Add Test</h6>
          <form [formGroup]="addTestForm" novalidate>
            <div class="row ml-0 mr-0">
              <div class="col-sm-12 col-md-4 relPos mb-2">
                <label for="activities_nv_test_name">Test Name <span class="text-danger">*</span></label>
                <mat-form-field
                  appearance="outline"
                  class="state-select-field activities-nv-test-name-mat"
                  [class.mat-field-invalid-border]="
                    addTestForm.get('testName')?.invalid && addTestForm.get('testName')?.touched
                  "
                  [matTooltip]="getSelectLabel(addTestForm.get('testName')?.value, testNameOptions)"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip">
                  <mat-select
                    id="activities_nv_test_name"
                    formControlName="testName"
                    [placeholder]="placeholderMessage['P0041'] || 'Select Test Name'"
                    disableOptionCentering
                    panelClass="activities-nv-test-name-panel"
                    (openedChange)="onNvTestNameSelectOpened($event)">
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="testNameFilterCtrl"
                        placeholderLabel="Type to search"
                        noEntriesFoundLabel="No tests found">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredTestNameOptions" [value]="opt.key">{{ opt.value }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <div
                  *ngIf="addTestForm.get('testName')?.touched && addTestForm.get('testName')?.errors?.['required']"
                  class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0065'] || 'Test Name is required.' }}
                </div>
              </div>
              <div class="col-sm-12 col-md-4 relPos mb-2">
                <label for="activities_nv_test_date">Test Date <span class="text-danger">*</span></label>
                <div class="input-group ssn-input-group">
                  <input
                    id="activities_nv_test_date"
                    type="text"
                    class="form-control formField date-uppercase"
                    formControlName="testDate"
                    maxlength="10"
                    (input)="onActivitiesTestDateInput($event, 'add')"
                    [attr.placeholder]="placeholderMessage['P0042'] || 'MM/DD/YYYY'"
                    [ngClass]="{
                      'is-invalid': addTestForm.get('testDate')?.invalid && addTestForm.get('testDate')?.touched
                    }" />
                  <span class="ssn-eye mt-1">
                    <button
                      type="button"
                      class="btn p-0 eye"
                      (click)="openActivitiesTestDatePicker($event, 'add')"
                      title="Open Calendar"
                      aria-label="Open date picker">
                      <span class="material-symbols-outlined f-20 cal">calendar_month</span>
                    </button>
                  </span>
                </div>
                <div *ngIf="addTestForm.get('testDate')?.touched && addTestForm.get('testDate')?.errors?.['required']" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0066'] || 'Test Date is required.' }}
                </div>
                <div *ngIf="addTestForm.get('testDate')?.touched && addTestForm.get('testDate')?.errors?.['testDateFormat']" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0063'] || 'Enter date as MM/DD/YYYY.' }}
                </div>
              </div>
              <div class="col-sm-12 col-md-4 relPos mb-2">
                <label for="activities_nv_score">Score <span class="text-danger">*</span></label>
                <input id="activities_nv_score" type="text" inputmode="decimal" class="formField" formControlName="score"
                  (keydown)="onScoreKeydown($event)"
                  (paste)="onScorePaste($event)"
                  [attr.placeholder]="placeholderMessage['P0043'] || ''" />
                <div *ngIf="addTestForm.get('score')?.touched && addTestForm.get('score')?.errors?.['required']" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0118']  }}
                </div>
                <div
                  *ngIf="
                    addTestForm.get('score')?.touched &&
                    (addTestForm.get('score')?.errors?.['pattern'] ||
                      addTestForm.get('score')?.errors?.['min'] ||
                      addTestForm.get('score')?.errors?.['max'])
                  "
                  class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0064'] || 'Accept only numbers upto 2 decimal places. Validation - 9999.99' }}
                </div>
              </div>
            </div>
            <div class="row ml-0 mr-0">
              <div class="col-12 d-flex justify-content-end activities-add-test-actions mt-1 mb-1">
                <button type="button" class="btn btn-outline-primary btn-sm activities-add-test-btn-cancel mr-2" (click)="onCancelAddTest()">Cancel</button>
                <button type="button" class="btn btn-primary btn-sm activities-add-test-btn-save" [disabled]="addTestForm.invalid" (click)="onSaveAddTest()">Save</button>
              </div>
            </div>
          </form>
        </div>

        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <ng-template #tplNevadaTestActions let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper">
                <button
                  type="button"
                  class="action-icon-button"
                  matTooltip="Edit"
                  matTooltipPosition="above"
                  (click)="onEditNevadaTest(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/edit-icon.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                    <svg width="24" height="24" viewBox="4 4 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                                            fill="#444444" />
                                    </svg>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button
                  type="button"
                  class="action-icon-button"
                  matTooltip="Delete"
                  matTooltipPosition="above"
                  (click)="onDeleteNevadaTest(data); $event.stopPropagation()">
                  <img src="assets/images/neveda-images/delete-icon.svg" alt="" width="20" height="20" aria-hidden="true" />
                </button>
              </span>
            </div>
          </ng-template>
          <app-data-grid #nevadaTestGrid
            [config]="nevadaTestingGridConfig"
            [activeTab]="'default'"
            [actionsTemplateRef]="tplNevadaTestActions"
            [wordWrapEnabled]="false">
          </app-data-grid>
        </div>

      <h6 class="document-grid-title">Supporting Documents</h6>

                <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <app-grid-actions
            [actions]="activitiesExportColumnChooserActions"
            [showColumnChooser]="showNvSupportingDocsColumnChooser"
            [allColumns]="nvSupportingDocsAllColumns"
            [visibleColumns]="nvSupportingDocsVisibleColumns"
            (exportClick)="exportNvSupportingDocs()"
            (columnChooserToggle)="toggleNvSupportingDocsColumnChooser()"
            (columnToggle)="onNvSupportingDocsColumnToggle($event)"
            (columnChooserClose)="closeNvSupportingDocsColumnChooser()">
          </app-grid-actions>
          <button type="button" class="btn btn-primary btn-sm ml-3" (click)="openSupportingDocUpload('nevada')">
            <i class="fa fa-upload mr-1" aria-hidden="true"></i> Upload
          </button>
        </div>
        </div>

        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <ng-template #tplNvDocActions let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button" matTooltip="View" matTooltipPosition="above" (click)="viewSupportingDocument(data); $event.stopPropagation()">
                 <span class="material-symbols-outlined">visibility</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button" matTooltip="Download" matTooltipPosition="above" (click)="downloadSupportingDocument(data); $event.stopPropagation()">
                 <span class="material-symbols-outlined">download</span>
                </button>
              </span>
            </div>
          </ng-template>
          <app-data-grid #nvSupportingDocsGrid [config]="nevadaSupportingDocsGridConfig" [activeTab]="'default'" [actionsTemplateRef]="tplNvDocActions"
          [statusDataField]="'document_status'"
          [submittedStatusValues]="['Uploaded', 'Verified', 'uploaded', 'verified']" [wordWrapEnabled]="false"></app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Out-of-State Testing + Supporting Documents -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleOosPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showOosPanel">
        <span class="panel-title mb-0">Other Testing</span>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="showOosPanel"
          (click)="toggleOosPanel(); $event.stopPropagation()"
          aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="!showOosPanel"
          (click)="toggleOosPanel(); $event.stopPropagation()"
          aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body" *ngIf="showOosPanel">
        <div *ngIf="!showOosAddTestForm" class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <app-grid-actions
            [actions]="activitiesExportColumnChooserActions"
            [showColumnChooser]="showOosTestingColumnChooser"
            [allColumns]="oosTestingAllColumns"
            [visibleColumns]="oosTestingVisibleColumns"
            (exportClick)="exportOosTesting()"
            (columnChooserToggle)="toggleOosTestingColumnChooser()"
            (columnToggle)="onOosTestingColumnToggle($event)"
            (columnChooserClose)="closeOosTestingColumnChooser()">
          </app-grid-actions>
          <button type="button" class="btn btn-primary btn-sm addpriporname ml-3" (click)="onAddOosTest()">
            <span class="material-symbols-outlined">add_circle</span> Add Test
          </button>
        </div>

        <!-- Inline OOS Add Test Form -->
        <div *ngIf="showOosAddTestForm" class="activities-add-test-section px-2 pb-2" (click)="$event.stopPropagation()">
          <h6 class="activities-add-test-title mb-3 mt-0">Other Testing – Add Test</h6>
          <form [formGroup]="oosAddTestForm" novalidate>
            <div class="row ml-0 mr-0">
              <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
                <label for="activities_oos_state">State <span class="text-danger">*</span></label>
                <mat-form-field
                  appearance="outline"
                  class="state-select-field activities-oos-state-mat"
                  [class.mat-field-invalid-border]="
                    oosAddTestForm.get('state')?.invalid && oosAddTestForm.get('state')?.touched
                  "
                  [matTooltip]="getStateLabel(oosAddTestForm.get('state')?.value, oosTestStateOptions)"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip">
                  <mat-select
                    id="activities_oos_state"
                    formControlName="state"
                    [placeholder]="placeholderMessage['P0031'] || 'Select State'"
                    disableOptionCentering
                    panelClass="activities-oos-state-search-panel"
                    (openedChange)="onOosStateSelectOpened($event)">
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="oosStateFilterCtrl"
                        placeholderLabel="Type to search"
                        noEntriesFoundLabel="No states found">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let state of filteredOosStateOptions" [value]="state.key">{{ state.value }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="oosAddTestForm.get('state')?.invalid && oosAddTestForm.get('state')?.touched" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0053'] }}
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
                <label for="activities_oos_test_name">Test Name <span class="text-danger">*</span></label>
                <input
                  id="activities_oos_test_name"
                  type="text"
                  class="formField"
                  formControlName="testName"
                  maxlength="60"
                  [placeholder]="placeholderMessage['P0041'] || ''" />
                <div *ngIf="oosAddTestForm.get('testName')?.invalid && oosAddTestForm.get('testName')?.touched" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0065'] || 'Enter a valid Test Name (letters, numbers, spaces, hyphens, apostrophes, periods; max 60 characters).' }}
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
                <label for="activities_oos_test_date">Test Date <span class="text-danger">*</span></label>
                <div class="input-group ssn-input-group">
                  <input
                    id="activities_oos_test_date"
                    type="text"
                    class="form-control formField date-uppercase"
                    formControlName="testDate"
                    maxlength="10"
                    (input)="onActivitiesTestDateInput($event, 'oos')"
                    [attr.placeholder]="placeholderMessage['P0042'] || 'MM/DD/YYYY'"
                    [ngClass]="{
                      'is-invalid': oosAddTestForm.get('testDate')?.invalid && oosAddTestForm.get('testDate')?.touched
                    }" />
                  <span class="ssn-eye mt-1">
                    <button
                      type="button"
                      class="btn p-0 eye"
                      (click)="openActivitiesTestDatePicker($event, 'oos')"
                      title="Open Calendar"
                      aria-label="Open date picker">
                      <span class="material-symbols-outlined f-20 cal">calendar_month</span>
                    </button>
                  </span>
                </div>
                <div *ngIf="oosAddTestForm.get('testDate')?.touched && oosAddTestForm.get('testDate')?.errors?.['required']" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0066'] || 'Test Date is required.' }}
                </div>
                <div *ngIf="oosAddTestForm.get('testDate')?.touched && oosAddTestForm.get('testDate')?.errors?.['testDateFormat']" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0063'] || 'Enter date as MM/DD/YYYY.' }}
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
                <label for="activities_oos_score">Score <span class="text-danger">*</span></label>
                <input id="activities_oos_score" type="text" inputmode="decimal" class="formField" formControlName="score"
                  (keydown)="onScoreKeydown($event)"
                  (paste)="onScorePaste($event)"
                  [attr.placeholder]="placeholderMessage['P0043'] || ''" />
                <div *ngIf="oosAddTestForm.get('score')?.touched && oosAddTestForm.get('score')?.errors?.['required']" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0067'] }}
                </div>
                <div
                  *ngIf="
                    oosAddTestForm.get('score')?.touched &&
                    (oosAddTestForm.get('score')?.errors?.['pattern'] ||
                      oosAddTestForm.get('score')?.errors?.['min'] ||
                      oosAddTestForm.get('score')?.errors?.['max'])
                  "
                  class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0064'] || 'Accept only numbers upto 2 decimal places. Validation - 9999.99' }}
                </div>
              </div>
            </div>
            <div class="row ml-0 mr-0">
              <div class="col-sm-12 col-md-6 col-lg-4 relPos mb-2">
                <label for="activities_oos_result">Result <span class="text-danger">*</span></label>
                <div class="dropdown-clear-wrapper activities-select-wrap">
                  <select id="activities_oos_result" class="formField form-control" formControlName="result" required
                    (change)="blurSelect($event)"
                    [ngClass]="{ 'is-invalid': oosAddTestForm.get('result')?.invalid && oosAddTestForm.get('result')?.touched }"
                    [matTooltip]="getSelectLabel(oosAddTestForm.get('result')?.value, oosResultOptions)"
                    matTooltipPosition="above"
                    matTooltipClass="custom-tooltip">
                    <!-- <option value="">{{ placeholderMessage['P0130'] || 'Select Result' }}</option> -->
                      <option value="" disabled selected hidden>{{ placeholderMessage['P0130'] || 'Select Result' }}</option>
                    <option *ngFor="let opt of oosResultOptions" [value]="opt.key">{{ opt.value }}</option>
                  </select>
                </div>
                <div *ngIf="oosAddTestForm.get('result')?.invalid && oosAddTestForm.get('result')?.touched" class="text-danger small mt-1 err-font">
                  {{ errorMessage['M0182'] || 'Result is required.' }}
                </div>
              </div>
            </div>
            <div class="row ml-0 mr-0">
              <div class="col-12 d-flex justify-content-end activities-add-test-actions mt-1 mb-1">
                <button type="button" class="btn btn-outline-primary btn-sm activities-add-test-btn-cancel mr-2" (click)="onCancelOosAddTest()">Cancel</button>
                <button type="button" class="btn btn-primary btn-sm activities-add-test-btn-save" [disabled]="oosAddTestForm.invalid" (click)="onSaveOosAddTest()">Save</button>
              </div>
            </div>
          </form>
        </div>

        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <ng-template #tplOosTestActions let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button" matTooltip="Edit" matTooltipPosition="above" (click)="onEditOosTest(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/edit-icon.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                    <svg width="24" height="24" viewBox="4 4 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                                            fill="#444444" />
                                    </svg>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button" matTooltip="Delete" matTooltipPosition="above" (click)="onDeleteOosTest(data); $event.stopPropagation()">
                  <img src="assets/images/neveda-images/delete-icon.svg" alt="" width="20" height="20" aria-hidden="true" />
                </button>
              </span>
            </div>
          </ng-template>
          <app-data-grid #oosTestGrid [config]="oosTestingGridConfig" [activeTab]="'default'" [actionsTemplateRef]="tplOosTestActions" [wordWrapEnabled]="false"></app-data-grid>
        </div>

      <h6 class="document-grid-title">Supporting Documents</h6>

                        <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <app-grid-actions
            [actions]="activitiesExportColumnChooserActions"
            [showColumnChooser]="showOosSupportingDocsColumnChooser"
            [allColumns]="oosSupportingDocsAllColumns"
            [visibleColumns]="oosSupportingDocsVisibleColumns"
            (exportClick)="exportOosSupportingDocs()"
            (columnChooserToggle)="toggleOosSupportingDocsColumnChooser()"
            (columnToggle)="onOosSupportingDocsColumnToggle($event)"
            (columnChooserClose)="closeOosSupportingDocsColumnChooser()">
          </app-grid-actions>
          <button type="button" class="btn btn-primary btn-sm ml-3" (click)="openSupportingDocUpload('oos')">
            <i class="fa fa-upload mr-1" aria-hidden="true"></i> Upload
          </button>
        </div>
        </div>

        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <ng-template #tplOosDocActions let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button" matTooltip="View" matTooltipPosition="above" (click)="viewSupportingDocument(data); $event.stopPropagation()">
                   <span class="material-symbols-outlined">visibility</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button" matTooltip="Download" matTooltipPosition="above" (click)="downloadSupportingDocument(data); $event.stopPropagation()">
                  <span class="material-symbols-outlined">download</span>
                </button>
              </span>
            </div>
          </ng-template>
          <app-data-grid #oosSupportingDocsGrid [config]="oosSupportingDocsGridConfig" [activeTab]="'default'" [actionsTemplateRef]="tplOosDocActions"
          [statusDataField]="'document_status'"
          [submittedStatusValues]="['Uploaded', 'Verified', 'uploaded', 'verified']" [wordWrapEnabled]="false"></app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Compliance -->
  <div class="row ml-0 mr-0" *ngIf="canViewCompliance">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleCompliancePanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showCompliancePanel">
        <span class="panel-title mb-0">Compliance</span>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="showCompliancePanel"
          (click)="toggleCompliancePanel(); $event.stopPropagation()"
          aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="!showCompliancePanel"
          (click)="toggleCompliancePanel(); $event.stopPropagation()"
          aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body" *ngIf="showCompliancePanel">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                          <div class="current-user-personal-container w-50">
                            <h6 class="current-user-personal-title">Background Check</h6>
                          </div>
                          <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2"
                            (click)="$event.stopPropagation()">
                            <app-grid-actions [actions]="activitiesExportColumnChooserActions" 
                              [showColumnChooser]="showBackgroundCheckColumnChooser" [allColumns]="backgroundCheckAllColumns"
                              [visibleColumns]="backgroundCheckVisibleColumns" (exportClick)="exportBackgroundCheck()"
                              (columnChooserToggle)="toggleBackgroundCheckColumnChooser()"
                              (columnToggle)="onBackgroundCheckColumnToggle($event)" (columnChooserClose)="closeBackgroundCheckColumnChooser()">
                            </app-grid-actions>
                          </div>
                        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-3" style="margin-left: 0; margin-right: 0">
          <app-data-grid #backgroundCheckGrid
            [config]="backgroundCheckGridConfig"
            [activeTab]="'default'"
            [onCaseIdClick]="onLookupCaseIdClick" [wordWrapEnabled]="false">
          </app-data-grid>
        </div>

        <div class="current-user-personal-container my-3">
          <h6 class="current-user-personal-title">History Disclosures</h6>
        </div>
        <div class="px-2 pb-3 activities-disclosures">
          <div *ngFor="let item of complianceDisclosures; let i = index" class="mb-3 border-bottom pb-3 activities-disclosure-item">
            <p class="mb-2 activities-disclosure-question">{{ item.question }}</p>
            <div class="d-flex align-items-center activities-disclosure-radios mb-2">
              <input
                type="radio"
                id="radio_disclosure_{{ i }}_yes"
                [name]="'disclosure_' + i"
                [checked]="item.yes === true"
                [disabled]="true"
                class="mr-1" />
              <label [attr.for]="'radio_disclosure_' + i + '_yes'" class="mb-0 mr-2">Yes</label>

              <input
                type="radio"
                id="radio_disclosure_{{ i }}_no"
                [name]="'disclosure_' + i"
                [checked]="item.yes === false"
                [disabled]="true"
                class="mr-1" />
              <label [attr.for]="'radio_disclosure_' + i + '_no'" class="mb-0">No</label>
            </div>
            <div *ngIf="item.description?.trim()" class="activities-disclosure-answer">
              <label class="small text-muted d-block">Description</label>
              <textarea class="form-control" rows="3" readonly [value]="item.description"
                [attr.placeholder]="placeholderMessage['P0048'] || ''"></textarea>
            </div>
          </div>
          <p *ngIf="complianceDisclosures.length === 0" class="text-muted small mb-0">No disclosure records from SP.</p>
        </div>

      <h6 class="document-grid-title">Supporting Documents</h6>

                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2"
                    (click)="$event.stopPropagation()">
                    <app-grid-actions [actions]="activitiesExportColumnChooserActions"
                      [showColumnChooser]="showComplianceSupportingDocsColumnChooser" [allColumns]="complianceSupportingDocsAllColumns"
                      [visibleColumns]="complianceSupportingDocsVisibleColumns" (exportClick)="exportComplianceSupportingDocs()"
                      (columnChooserToggle)="toggleComplianceSupportingDocsColumnChooser()"
                      (columnToggle)="onComplianceSupportingDocsColumnToggle($event)"
                      (columnChooserClose)="closeComplianceSupportingDocsColumnChooser()">
                    </app-grid-actions>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openComplianceHistoryDisclosureUpload()">
                      <i class="fa fa-upload mr-1" aria-hidden="true"></i> Upload
                    </button>
                  </div>


                </div>

        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <ng-template #tplComplianceHdDocActions let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button" matTooltip="View" matTooltipPosition="above" (click)="viewSupportingDocument(data); $event.stopPropagation()">
                   <span class="material-symbols-outlined">visibility</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button" matTooltip="Download" matTooltipPosition="above" (click)="downloadSupportingDocument(data); $event.stopPropagation()">
                  <span class="material-symbols-outlined">download</span>
                </button>
              </span>
            </div>
          </ng-template>
          <app-data-grid #complianceSupportingDocsGrid
            [config]="complianceSupportingDocsGridConfig"
            [activeTab]="'default'"
            [actionsTemplateRef]="tplComplianceHdDocActions"
            [onApplicationClick]="onLookupApplicationIdClick"
            [statusDataField]="'document_status'"
            [submittedStatusValues]="['Archived', 'archived', 'uploaded', 'verified']"
            [wordWrapEnabled]="false">
          </app-data-grid>
        </div>
      </div>
    </div>
  </div>

  <!-- Documents (Active / Archived) -->
  <div class="row ml-0 mr-0">
    <div class="panel-blue w-100">
      <div
        class="header d-flex justify-content-between align-items-center"
        (click)="toggleDocumentsPanel()"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showDocumentsPanel">
        <span class="panel-title mb-0">Documents</span>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="showDocumentsPanel"
          (click)="toggleDocumentsPanel(); $event.stopPropagation()"
          aria-label="Collapse">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="toggle-panel position-static"
          *ngIf="!showDocumentsPanel"
          (click)="toggleDocumentsPanel(); $event.stopPropagation()"
          aria-label="Expand">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>
      <div class="panel-body" *ngIf="showDocumentsPanel">
        <h6 class="document-grid-title">Supporting Documents</h6>
        <div class="lookup-datagrid-toolbar lookup-user-action-grid d-flex justify-content-end align-items-center flex-wrap py-2 px-2 gap-2" (click)="$event.stopPropagation()">
          <app-grid-actions
            [actions]="activitiesExportColumnChooserActions"
            [showColumnChooser]="showProfileDocumentsColumnChooser"
            [allColumns]="profileDocumentsAllColumns"
            [visibleColumns]="profileDocumentsVisibleColumns"
            (exportClick)="exportProfileDocuments()"
            (columnChooserToggle)="toggleProfileDocumentsColumnChooser()"
            (columnToggle)="onProfileDocumentsColumnToggle($event)"
            (columnChooserClose)="closeProfileDocumentsColumnChooser()">
          </app-grid-actions>
          <button type="button" class="btn btn-primary btn-sm upload-btn" (click)="openUploadDocumentModal()">
            <span class="material-symbols-outlined">upload</span> Upload
          </button>
        </div>
         <div class="d-flex flex-wrap align-items-center justify-content-between px-2 pt-2 pb-1 gap-2">
          <ul class="nav nav-pills activities-doc-tabs mb-0">
            <li class="nav-item">
              <button
                type="button"
                class="nav-link"
                [class.active]="documentsTab === 'active'"
                (click)="onDocumentsTab('active')">
                Active Documents
              </button>
            </li>
            <li class="nav-item">
              <button
                type="button"
                class="nav-link"
                [class.active]="documentsTab === 'archived'"
                (click)="onDocumentsTab('archived')">
                Archived Documents
              </button>
            </li>
          </ul>
        </div>
        <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left: 0; margin-right: 0">
          <ng-template #tplProfileDocActions let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button" pTooltip="Edit"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="openEditDocumentModal(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/edit-icon.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                   <svg width="24" height="24" viewBox="4 4 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                                            fill="#444444" />
                                    </svg>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button" pTooltip="View"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="viewProfileDocument(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/eye.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                   <span class="material-symbols-outlined">visibility</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button" pTooltip="Download"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="downloadProfileDocument(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/download.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                   <span class="material-symbols-outlined">download</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1" *ngIf="documentsTab === 'active'">
                <button type="button" class="action-icon-button" pTooltip="Archive"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="confirmArchiveDocument(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/archive.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                   <span class="material-symbols-outlined">archive</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1" *ngIf="documentsTab === 'archived'">
                <button type="button" class="action-icon-button" pTooltip="Unarchive"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="confirmUnarchiveDocument(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/unarchive.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                   <span class="material-symbols-outlined">unarchive</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1" *ngIf="canShowDeleteProfileDocument(data)">
                <button type="button" class="action-icon-button deletebtn" pTooltip="Delete"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"  (click)="confirmDeleteDocument(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/delete-icon.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                   <span class="material-symbols-outlined">
delete
</span>
                </button>
              </span>
            </div>
          </ng-template>
          <div class="lookup-user-activites-datagrid">
            <app-data-grid #profileDocumentsGrid
            [config]="profileDocumentsGridConfig"
            [activeTab]="'default'"
            [actionsTemplateRef]="tplProfileDocActions"
            [onApplicationClick]="onLookupApplicationIdClick" [wordWrapEnabled]="true"
            [statusDataField]="'document_status'"
            [submittedStatusValues]="['Active', 'active', 'Verified', 'verified']"
            [wordWrapEnabled]="false">
          </app-data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Document Modal -->
<ng-template #editDocumentModal let-modal>
  <div class="upload-form-popup">
    <div class="form-modal-header p-4 d-flex justify-content-between align-items-center">
      <h4 class="modal-title">Edit Document</h4>
      <button type="button" class="close" aria-label="Close" (click)="closeEditDocumentModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="form-modal-body px-4 pt-4 pb-2" [formGroup]="editDocForm">
      <div class="row mb-3">
        <div class="col-md-6">
          <label class="form-label fw-bold">Category<span class="text-danger">*</span></label>
          <div class="dropdown-clear-wrapper activities-select-wrap">
            <select class="form-control" formControlName="category" (focus)="openSelectArrow($event)" (blur)="onSelectBlur($event)" (change)="onEditDocCategoryChange(); closeSelectArrow($event)"
              [matTooltip]="getCategoryLabel(editDocForm.get('category')?.value, editDocCategoryOptions)"
              matTooltipPosition="above"
              matTooltipClass="custom-tooltip">
              <option value="">Select Category</option>
              <option *ngFor="let cat of editDocCategoryOptions" [value]="cat.key">{{ cat.value }}</option>
            </select>
          </div>
          <div *ngIf="editDocForm.get('category')?.invalid && editDocForm.get('category')?.touched" class="text-danger small mt-1 err-font">
            {{ errorMessage['M0048'] || 'Category is required.' }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-bold">Type<span class="text-danger">*</span></label>
          <div class="dropdown-clear-wrapper activities-select-wrap">
            <select class="form-control" formControlName="type"
              (change)="blurSelect($event)"
              [matTooltip]="getSelectLabel(editDocForm.get('type')?.value, filteredDocTypeOptions)"
              matTooltipPosition="above"
              matTooltipClass="custom-tooltip">
              <option value="">Select Type</option>
              <option *ngFor="let dt of filteredDocTypeOptions" [value]="dt.key">{{ dt.value }}</option>
            </select>
          </div>
          <div *ngIf="editDocForm.get('type')?.invalid && editDocForm.get('type')?.touched" class="text-danger small mt-1 err-font">
            {{ errorMessage['M0049'] || 'Type is required.' }}
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label fw-bold">Notes<span class="text-danger">*</span></label>
        <textarea class="form-control" rows="4" formControlName="notes" placeholder="Enter notes..."></textarea>
        <div *ngIf="editDocForm.get('notes')?.invalid && editDocForm.get('notes')?.touched" class="text-danger small mt-1 err-font">
          {{ errorMessage['M0126'] || 'Note is required.' }}
        </div>
      </div>
    </div>
    <div class="modal-footer border-top d-flex gap-2">
      <button type="button" class="btn-cancel btn btn-outline-secondary btn-md px-3 py-1" (click)="onResetEditDocumentForm()">Reset</button>
      <button class="btn btn-md px-3 py-1 btnprimary" type="button" (click)="onUpdateDocument()">Update</button>
    </div>
  </div>
</ng-template>

<!-- Upload Document Modal -->
<ng-template #uploadDocumentModal let-modal>
  <div class="modal-header border-bottom align-items-center">
    <h4 class="modal-title mb-0 font-weight-bold text-dark">Upload Files</h4>
    <button type="button" class="close activities-modal-dismiss" aria-label="Close" (click)="closeUploadDocumentModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" [formGroup]="uploadDocForm">
    <div class="form-group mb-2">
      <label class="font-weight-bold d-block">Supporting Document <span class="text-danger">*</span></label>
      <input #docFileInputRef type="file" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
        (click)="clearFileInput($event)" (change)="handleDocFileUpload($event)" />
      <div class="doc-upload-dropzone text-center p-4 rounded"
        [class.doc-upload-dropzone--active]="docDropzoneActive"
        (dragover)="onDocDragOver($event)"
        (dragleave)="onDocDragLeave($event)"
        (drop)="onDropDocFile($event)"
        (click)="docFileInputRef.click()"
        role="button" tabindex="0">
        <div class="doc-upload-icon rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center">
          <span class="material-symbols-outlined"> upload </span>
        </div>
        <div class="doc-upload-hint">
          Drag &amp; drop or
          <a class="doc-choose-link" (click)="$event.preventDefault(); $event.stopPropagation(); docFileInputRef.click()">choose file</a>
          to upload
        </div>
      </div>
      <div class="doc-file-row mt-3 d-flex align-items-center border-top pt-3" *ngIf="docUploadFile; else noDocFile">
        <i class="fa fa-file-text text-primary mr-2" aria-hidden="true"></i>
        <span class="flex-grow-1 text-truncate">{{ docUploadFile.name }}</span>
        <button type="button" class="btn btn-link btn-sm py-0" (click)="clearDocUploadFile(); $event.stopPropagation()">Remove</button>
      </div>
      <!-- <ng-template #noDocFile>
        <div class="doc-file-row mt-3 d-flex align-items-center text-muted border-top pt-3">
          <i class="fa fa-file-o text-primary mr-2" aria-hidden="true"></i>
          <span>No file uploaded</span>
        </div>
      </ng-template> -->
            <ng-template #noDocFile>
        <!-- <div class="lookup-staff-file-row mt-3 d-flex align-items-center text-muted border-top pt-3">
          <i class="fa fa-file-o text-primary mr-2" aria-hidden="true"></i>
          <span>No file uploaded</span>
        </div> -->
          <div class="no-file-uploaded mt-20">
          <i  class="pi pi-file"></i>
          <span>No file uploaded</span>
        </div>
      </ng-template>
      <div *ngIf="docUploadError" class="text-danger small mt-2">{{ docUploadError }}</div>
      <p class="filesformat mb-0 mt-3">Supported formats: PDF, JPG, JPEG, PNG.<br />Maximum size: 15 MB.</p>
    </div>

    <div class="row mb-3 mt-3">
      <div class="col-md-6">
        <label class="form-label fw-bold ufcustom-req-label">Category<span class="text-danger">*</span></label>
        <!-- <select class="form-control" formControlName="category" (change)="onUploadDocCategoryChange()"
          [matTooltip]="getSelectLabel(uploadDocForm.get('category')?.value, uploadDocCategoryOptions)"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip">
          <option value="">{{ placeholderMessage['P0029'] || 'Select Category' }}</option>
          <option *ngFor="let cat of uploadDocCategoryOptions" [value]="cat.key">{{ cat.value }}</option>
        </select> -->
        <p-dropdown #uploadDocCategoryDropdown [options]="uploadDocCategoryOptions" formControlName="category" optionLabel="value" optionValue="key"
          [placeholder]="placeholderMessage['P0029'] || 'Select Category'" [filter]="true" filterBy="value"
          filterMatchMode="contains" (onChange)="onUploadDocCategoryChange($event)"
          appendTo="body" [baseZIndex]="1100" panelStyleClass="lookup-upload-type-panel"
          (onShow)="onUploadTypeDropdownShow(uploadDocCategoryDropdown)"
          [matTooltip]="getSelectLabel(uploadDocForm.get('category')?.value, uploadDocCategoryOptions)" matTooltipPosition="above"
          matTooltipClass="custom-tooltip" styleClass="ufcustom-req-dropdown">
        </p-dropdown>
        <div *ngIf="uploadDocForm.get('category')?.invalid && uploadDocForm.get('category')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0048'] || 'Category is required.' }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold">Type<span class="text-danger">*</span></label>
        <!-- <select class="form-control" formControlName="type"
          [matTooltip]="getSelectLabel(uploadDocForm.get('type')?.value, uploadFilteredDocTypeOptions)"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip">
          <option value="">{{ placeholderMessage['P0030'] || 'Select Type' }}</option>
          <option *ngFor="let dt of uploadFilteredDocTypeOptions" [value]="dt.key">{{ dt.value }}</option>
        </select> -->
        <p-dropdown #uploadDocTypeDropdown [options]="uploadFilteredDocTypeOptions" formControlName="type" optionLabel="value" optionValue="key"
          [placeholder]="placeholderMessage['P0030'] || 'Select Type'" [filter]="true" filterBy="value"
          filterMatchMode="contains"
          appendTo="body" [baseZIndex]="1100" panelStyleClass="lookup-upload-type-panel"
          (onShow)="onUploadTypeDropdownShow(uploadDocTypeDropdown)"
          [matTooltip]="getSelectLabel(uploadDocForm.get('type')?.value, uploadFilteredDocTypeOptions)"
          matTooltipPosition="above" matTooltipClass="custom-tooltip" styleClass="ufcustom-req-dropdown">
        </p-dropdown>
        <div *ngIf="uploadDocForm.get('type')?.invalid && uploadDocForm.get('type')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0049'] || 'Type is required.' }}
        </div>
      </div>
    </div>
    <!-- Notes hidden on add; Edit Document modal still collects notes. -->
    <!--
    <div class="mb-3">
      <label class="form-label fw-bold">Notes</label>
      <textarea class="form-control" rows="4" formControlName="notes"></textarea>
    </div>
    -->
  </div>
  <div class="modal-footer border-top d-flex gap-2">
    <button type="button" class="btn btn-outline-primary" (click)="closeUploadDocumentModal()">Cancel</button>
    <button class="btn btn-primary" type="button"
      [disabled]="!docUploadFile || uploadDocForm.invalid"
      (click)="onSaveDocumentUpload()">Upload</button>
  </div>
</ng-template>

<!-- Supporting Doc Upload Modal (Nevada / OOS) -->
<ng-template #supportingDocUploadModalTpl let-modal>
  <div class="modal-header border-bottom align-items-center">
    <h4 class="modal-title mb-0 font-weight-bold text-dark">Upload Files</h4>
    <button type="button" class="close activities-modal-dismiss" aria-label="Close" (click)="closeSupportingDocUploadModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" [formGroup]="supportingDocUploadForm">
    <div class="form-group mb-2">
      <label class="font-weight-bold d-block">Supporting Document <span class="text-danger">*</span></label>
      <input #supportingDocFileInput type="file" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
        (click)="clearFileInput($event)" (change)="handleDocFileUpload($event)" />
      <div class="doc-upload-dropzone text-center p-4 rounded"
        [class.doc-upload-dropzone--active]="docDropzoneActive"
        (dragover)="onDocDragOver($event)"
        (dragleave)="onDocDragLeave($event)"
        (drop)="onDropDocFile($event)"
        (click)="supportingDocFileInput.click()"
        role="button" tabindex="0">
        <div class="doc-upload-icon rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center">
          <span class="material-symbols-outlined"> upload </span>
        </div>
        <div class="doc-upload-hint">
          Drag &amp; drop or
          <a class="doc-choose-link" (click)="$event.preventDefault(); $event.stopPropagation(); supportingDocFileInput.click()">choose file</a>
          to upload
        </div>
      </div>
      <div class="doc-file-row mt-3 d-flex align-items-center border-top pt-3" *ngIf="docUploadFile; else noSupportingDocFile">
        <i class="fa fa-file-text text-primary mr-2" aria-hidden="true"></i>
        <span class="flex-grow-1 text-truncate">{{ docUploadFile.name }}</span>
        <button type="button" class="btn btn-link btn-sm py-0" (click)="clearDocUploadFile(); $event.stopPropagation()">Remove</button>
      </div>
      <ng-template #noSupportingDocFile>
          <div class="no-file-uploaded mt-20">
          <i  class="pi pi-file"></i>
          <span>No file uploaded</span>
        </div>
      </ng-template>

      <div *ngIf="docUploadError" class="text-danger small mt-2">{{ docUploadError }}</div>
      <p class="filesformat mb-0 mt-3">Supported formats: PDF, JPG, JPEG, PNG.<br />Maximum size: 15 MB.</p>
    </div>

    <div class="row mb-3 mt-3">
      <div class="col-md-6">
        <label class="form-label fw-bold">Category<span class="text-danger">*</span></label>
        <ng-container *ngIf="supportingDocUploadCategoryDisabled; else supportingDocUploadCategoryDropdown">
          <input type="text" class="form-control" [value]="supportingDocUploadCategoryLabel" disabled />
        </ng-container>
        <ng-template #supportingDocUploadCategoryDropdown>
          <p-dropdown
            [options]="supportingDocUploadCategoryOptions"
            formControlName="category"
            optionLabel="value"
            optionValue="key"
            [placeholder]="placeholderMessage['P0029'] || 'Select Category'"
            [filter]="true"
            filterBy="value"
            filterMatchMode="contains"
            (onChange)="onSupportingDocCategoryChange($event.value)"
            [matTooltip]="getSelectLabel(supportingDocUploadForm.get('category')?.value, supportingDocUploadCategoryOptions)"
            matTooltipPosition="above"
            matTooltipClass="custom-tooltip"
            styleClass="ufcustom-req-dropdown">
          </p-dropdown>
        </ng-template>
        <div *ngIf="supportingDocUploadCategoryOptions.length === 0" class="text-warning small mt-1">
          Loading categories…
        </div>
        <div *ngIf="supportingDocUploadForm.get('category')?.invalid && supportingDocUploadForm.get('category')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0048'] || 'Category is required.' }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold ufcustom-req-label">Type<span class="text-danger">*</span></label>
        <!-- <select class="form-control" formControlName="type"
          [matTooltip]="getSelectLabel(supportingDocUploadForm.get('type')?.value, supportingDocTypeOptions)"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip">
          <option value="">{{ placeholderMessage['P0030'] || 'Select Type' }}</option>
          <option *ngFor="let dt of supportingDocTypeOptions" [value]="dt.key">{{ dt.value }}</option>
        </select> -->
        <p-dropdown #supportingDocTypeDropdown [options]="supportingDocTypeOptions" formControlName="type" optionLabel="value" optionValue="key"
          [placeholder]="placeholderMessage['P0030'] || 'Select Type'" [filter]="true" filterBy="value"
          filterMatchMode="contains"
          appendTo="body" [baseZIndex]="1100" panelStyleClass="lookup-upload-type-panel"
          (onShow)="onUploadTypeDropdownShow(supportingDocTypeDropdown)"
          [matTooltip]="getSelectLabel(supportingDocUploadForm.get('type')?.value, supportingDocTypeOptions)"
          matTooltipPosition="above" matTooltipClass="custom-tooltip"
          styleClass="ufcustom-req-dropdown">
        </p-dropdown>
        <div *ngIf="supportingDocUploadForm.get('type')?.invalid && supportingDocUploadForm.get('type')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0049'] || 'Type is required.' }}
        </div>
      </div>
    </div>
    <!-- Notes hidden on add; Edit Document modal still collects notes. -->
    <!--
    <div class="mb-3">
      <label class="form-label fw-bold">Notes</label>
      <textarea class="form-control" rows="4" formControlName="notes"></textarea>
    </div>
    -->
  </div>
  <div class="modal-footer border-top d-flex gap-2">
    <button type="button" class="btn btn-outline-primary" (click)="closeSupportingDocUploadModal()">Cancel</button>
    <button class="btn btn-primary" type="button"
      [disabled]="!docUploadFile || supportingDocUploadForm.invalid"
      (click)="onSaveSupportingDocUpload()">Upload</button>
  </div>
</ng-template>

<!-- Compliance: History Disclosure Supporting — Upload Files -->
<ng-template #complianceHdUploadModalTpl let-modal>
  <div class="modal-header border-bottom align-items-center">
    <h4 class="modal-title mb-0 font-weight-bold text-dark">Upload Files</h4>
    <button type="button" class="close activities-modal-dismiss" aria-label="Close" (click)="closeComplianceHistoryDisclosureUploadModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" [formGroup]="complianceHdUploadForm">
    <div class="form-group mb-2">
      <label class="font-weight-bold d-block">History Disclosure – Supporting Document <span class="text-danger">*</span></label>
      <input #complianceHdFileInput type="file" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
        (click)="clearFileInput($event)" (change)="handleDocFileUpload($event)" />
      <div class="doc-upload-dropzone text-center p-4 rounded"
        [class.doc-upload-dropzone--active]="docDropzoneActive"
        (dragover)="onDocDragOver($event)"
        (dragleave)="onDocDragLeave($event)"
        (drop)="onDropDocFile($event)"
        (click)="complianceHdFileInput.click()"
        role="button" tabindex="0">
        <div class="doc-upload-icon rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center">
          <span class="material-symbols-outlined"> upload </span>
        </div>
        <div class="doc-upload-hint">
          Drag &amp; drop or
          <a class="doc-choose-link" (click)="$event.preventDefault(); $event.stopPropagation(); complianceHdFileInput.click()">choose file</a>
          to upload
        </div>
      </div>
      <div class="doc-file-row mt-3 d-flex align-items-center border-top pt-3" *ngIf="docUploadFile; else noComplianceHdFile">
        <i class="fa fa-file-text text-primary mr-2" aria-hidden="true"></i>
        <span class="flex-grow-1 text-truncate">{{ docUploadFile.name }}</span>
        <button type="button" class="btn btn-link btn-sm py-0" (click)="clearDocUploadFile(); $event.stopPropagation()">Remove</button>
      </div>
      <ng-template #noComplianceHdFile>
          <div class="no-file-uploaded mt-20">
          <i  class="pi pi-file"></i>
          <span>No file uploaded</span>
        </div>
      </ng-template>
      <div *ngIf="docUploadError" class="text-danger small mt-2">{{ docUploadError }}</div>
      <p class="filesformat mb-0 mt-3">Supported formats: PDF, JPG, JPEG, PNG.<br />Maximum size: 15 MB.</p>
    </div>

    <div class="row mb-3 mt-3">
      <div class="col-md-6">
        <label class="form-label fw-bold ufcustom-req-label">Category<span class="text-danger">*</span></label>
        <!-- <select class="form-control" formControlName="category" (change)="onComplianceHistoryDisclosureCategoryChange()"
          [matTooltip]="getSelectLabel(complianceHdUploadForm.get('category')?.value, complianceHdCategoryRows)"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip">
          <option value="">Select Category</option>
          <option *ngFor="let c of complianceHdCategoryRows" [value]="c.key">{{ c.value }}</option>
        </select> -->
        <p-dropdown [options]="complianceHdCategoryRows" formControlName="category" optionLabel="value" optionValue="key"
          placeholder="Select Category" [filter]="true" filterBy="value" filterMatchMode="contains"
          (onChange)="onComplianceHistoryDisclosureCategoryChange($event)"
          [matTooltip]="getSelectLabel(complianceHdUploadForm.get('category')?.value, complianceHdCategoryRows)"
          matTooltipPosition="above" matTooltipClass="custom-tooltip" styleClass="ufcustom-req-dropdown">
        </p-dropdown>
        <div *ngIf="complianceHdCategoryLoadError" class="text-warning small mt-1">{{ complianceHdCategoryLoadError }}</div>
        <div *ngIf="complianceHdCategoryLookupMissing" class="text-danger small mt-1">
          Select a valid category from the list.
        </div>
        <div *ngIf="complianceHdUploadForm.get('category')?.invalid && complianceHdUploadForm.get('category')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0050'] || 'Category is required.' }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold ufcustom-req-label">Type<span class="text-danger">*</span></label>
        <!-- <select class="form-control" formControlName="type"
          [matTooltip]="getSelectLabel(complianceHdUploadForm.get('type')?.value, complianceHdFilteredTypeOptions)"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip">
          <option value="">Select document type</option>
          <option *ngFor="let dt of complianceHdFilteredTypeOptions" [value]="dt.key">{{ dt.value }}</option>
        </select> -->
        <p-dropdown #complianceHdTypeDropdown [options]="complianceHdFilteredTypeOptions" formControlName="type" optionLabel="value" optionValue="key"
          placeholder="Select document type" [filter]="true" filterBy="value" filterMatchMode="contains"
          appendTo="body" [baseZIndex]="1100" panelStyleClass="lookup-upload-type-panel"
          (onShow)="onUploadTypeDropdownShow(complianceHdTypeDropdown)"
          [matTooltip]="getSelectLabel(complianceHdUploadForm.get('type')?.value, complianceHdFilteredTypeOptions)"
          matTooltipPosition="above" matTooltipClass="custom-tooltip" styleClass="ufcustom-req-dropdown">
        </p-dropdown>
        <div *ngIf="complianceHdTypesLoadError" class="text-warning small mt-1">{{ complianceHdTypesLoadError }}</div>
        <div *ngIf="complianceHdUploadForm.get('type')?.invalid && complianceHdUploadForm.get('type')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0049'] || 'Type is required.' }}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-top d-flex gap-2">
    <button type="button" class="btn btn-outline-primary" (click)="closeComplianceHistoryDisclosureUploadModal()">Cancel</button>
    <button class="btn btn-primary" type="button"
      [disabled]="!docUploadFile || complianceHdUploadForm.invalid || complianceHdCategoryLookupMissing || complianceSupportingUploadSaving"
      (click)="onSaveComplianceHistoryDisclosureUpload()">Upload</button>
  </div>
</ng-template>

<!-- Edit Nevada Test Modal -->
<ng-template #editNevadaTestModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Edit Record</h4>
    <!-- <button type="button" class="close activities-modal-dismiss" aria-label="Close" (click)="editNevadaTestModalRef?.close()">
      <span aria-hidden="true">&times;</span>
    </button> -->
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg" (click)="editNevadaTestModalRef?.close()" (keypress)="editNevadaTestModalRef?.close()" alt="close_icon" tabindex="0">
    </div>
  </div>
  <div class="modal-body" [formGroup]="editNevadaTestForm">
    <div class="row mb-3">
      <div class="col-md-4">
        <label class="form-label fw-bold">Test Name <span class="text-danger">*</span></label>
        <mat-form-field
          appearance="outline"
          class="state-select-field activities-nv-test-name-mat"
          [class.mat-field-invalid-border]="
            editNevadaTestForm.get('testName')?.invalid && editNevadaTestForm.get('testName')?.touched
          ">
          <mat-select
            id="editNevadadrp"
            formControlName="testName"
            [placeholder]="placeholderMessage['P0041'] || 'Select Test Name'"
            disableOptionCentering
            panelClass="activities-nv-test-name-panel"
            (openedChange)="onNvTestNameSelectOpened($event)">
            <mat-option>
              <ngx-mat-select-search
                [formControl]="testNameFilterCtrl"
                placeholderLabel="Type to search"
                noEntriesFoundLabel="No tests found">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let opt of filteredTestNameOptions" [value]="opt.key">{{ opt.value }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="editNevadaTestForm.get('testName')?.invalid && editNevadaTestForm.get('testName')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0065'] || 'Test Name is required.' }}
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label fw-bold" for="activities_edit_nevada_test_date">Test Date <span class="text-danger">*</span></label>
        <div class="input-group ssn-input-group">
          <input
            id="activities_edit_nevada_test_date"
            type="text"
            class="form-control date-uppercase"
            formControlName="testDate"
            maxlength="10"
            (input)="onActivitiesTestDateInput($event, 'editNv')"
            [attr.placeholder]="placeholderMessage['P0042'] || 'MM/DD/YYYY'"
            [ngClass]="{
              'is-invalid': editNevadaTestForm.get('testDate')?.invalid && editNevadaTestForm.get('testDate')?.touched
            }" />
          <span class="ssn-eye">
            <button
              type="button"
              class="btn p-0 eye"
              (click)="openActivitiesTestDatePicker($event, 'editNv')"
              title="Open Calendar"
              aria-label="Open date picker">
              <span class="material-symbols-outlined f-20 cal">calendar_month</span>
            </button>
          </span>
        </div>
        <div *ngIf="editNevadaTestForm.get('testDate')?.touched && editNevadaTestForm.get('testDate')?.errors?.['required']" class="text-danger small mt-1">
          {{ errorMessage['M0066'] || 'Test Date is required.' }}
        </div>
        <div *ngIf="editNevadaTestForm.get('testDate')?.touched && editNevadaTestForm.get('testDate')?.errors?.['testDateFormat']" class="text-danger small mt-1">
          {{ errorMessage['M0063'] || 'Enter date as MM/DD/YYYY.' }}
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label fw-bold">Score <span class="text-danger">*</span></label>
        <input type="text" inputmode="decimal" class="form-control" formControlName="score"
          (keydown)="onScoreKeydown($event)"
          (paste)="onScorePaste($event)"
          [attr.placeholder]="placeholderMessage['P0043'] || ''" />
        <div *ngIf="editNevadaTestForm.get('score')?.touched && editNevadaTestForm.get('score')?.errors?.['required']" class="text-danger small mt-1">
          {{ errorMessage['M0118'] }}
        </div>
        <div
          *ngIf="
            editNevadaTestForm.get('score')?.touched &&
            (editNevadaTestForm.get('score')?.errors?.['pattern'] ||
              editNevadaTestForm.get('score')?.errors?.['min'] ||
              editNevadaTestForm.get('score')?.errors?.['max'])
          "
          class="text-danger small mt-1">
          {{ errorMessage['M0064'] || 'Enter a valid score greater than 0 (up to 9999.99, max 2 decimal places).' }}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4" (click)="onResetEditNevadaTestForm()">Reset</button>
    <button type="button" class="btn btn-primary btn-lg btnprimary" (click)="onSaveNevadaTestEdit()">Update</button>
  </div>
</ng-template>

<!-- Edit OOS Test Modal -->
<ng-template #editOosTestModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Edit Record</h4>
    <!-- <button type="button" class="close activities-modal-dismiss" aria-label="Close" (click)="editOosTestModalRef?.close()">
      <span aria-hidden="true">&times;</span>
    </button> -->
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg" (click)="editOosTestModalRef?.close()" (keypress)="editOosTestModalRef?.close()" alt="close_icon" tabindex="0">
    </div>
  </div>
  <div class="modal-body" [formGroup]="editOosTestForm">
    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label fw-bold" for="activities_edit_oos_state">State <span class="text-danger">*</span></label>
        <mat-form-field
          appearance="outline"
          class="state-select-field activities-oos-state-mat w-100"
          [class.mat-field-invalid-border]="
            editOosTestForm.get('state')?.invalid && editOosTestForm.get('state')?.touched
          "
          [matTooltip]="getSelectLabel(editOosTestForm.get('state')?.value, oosTestStateOptions)"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip">
          <mat-select
            id="activities_edit_oos_state"
            formControlName="state"
            [placeholder]="placeholderMessage['P0031'] || 'Select State'"
            disableOptionCentering
            panelClass="activities-oos-state-search-panel"
            (openedChange)="onOosStateSelectOpened($event)">
            <mat-option>
              <ngx-mat-select-search
                [formControl]="oosStateFilterCtrl"
                placeholderLabel="Type to search"
                noEntriesFoundLabel="No states found">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let state of filteredOosStateOptions" [value]="state.key">{{ state.value }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="editOosTestForm.get('state')?.invalid && editOosTestForm.get('state')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0053'] || 'State is required.' }}
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-bold">Test Name <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          formControlName="testName"
          maxlength="60"
          [attr.placeholder]="placeholderMessage['P0041'] || ''" />
        <div *ngIf="editOosTestForm.get('testName')?.invalid && editOosTestForm.get('testName')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0065'] || 'Enter a valid Test Name (letters, numbers, spaces, hyphens, apostrophes, periods; max 60 characters).' }}
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-bold" for="activities_edit_oos_test_date">Test Date <span class="text-danger">*</span></label>
        <div class="input-group ssn-input-group">
          <input
            id="activities_edit_oos_test_date"
            type="text"
            class="form-control date-uppercase"
            formControlName="testDate"
            maxlength="10"
            (input)="onActivitiesTestDateInput($event, 'editOos')"
            [attr.placeholder]="placeholderMessage['P0042'] || 'MM/DD/YYYY'"
            [ngClass]="{
              'is-invalid': editOosTestForm.get('testDate')?.invalid && editOosTestForm.get('testDate')?.touched
            }" />
          <span class="ssn-eye">
            <button
              type="button"
              class="btn p-0 eye"
              (click)="openActivitiesTestDatePicker($event, 'editOos')"
              title="Open Calendar"
              aria-label="Open date picker">
              <span class="material-symbols-outlined f-20 cal">calendar_month</span>
            </button>
          </span>
        </div>
        <div *ngIf="editOosTestForm.get('testDate')?.touched && editOosTestForm.get('testDate')?.errors?.['required']" class="text-danger small mt-1">
          {{ errorMessage['M0066'] || 'Test Date is required.' }}
        </div>
        <div *ngIf="editOosTestForm.get('testDate')?.touched && editOosTestForm.get('testDate')?.errors?.['testDateFormat']" class="text-danger small mt-1">
          {{ errorMessage['M0063'] || 'Enter date as MM/DD/YYYY.' }}
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-bold">Score <span class="text-danger">*</span></label>
        <input type="text" inputmode="decimal" class="form-control" formControlName="score"
          (keydown)="onScoreKeydown($event)"
          (paste)="onScorePaste($event)"
          [attr.placeholder]="placeholderMessage['P0043'] || ''" />
        <div *ngIf="editOosTestForm.get('score')?.touched && editOosTestForm.get('score')?.errors?.['required']" class="text-danger small mt-1">
          {{ errorMessage['M0067']  }}
        </div>
        <div
          *ngIf="
            editOosTestForm.get('score')?.touched &&
            (editOosTestForm.get('score')?.errors?.['pattern'] ||
              editOosTestForm.get('score')?.errors?.['min'] ||
              editOosTestForm.get('score')?.errors?.['max'])
          "
          class="text-danger small mt-1">
          {{ errorMessage['M0064'] || 'Accept only numbers upto 2 decimal places. Validation - 9999.99' }}
        </div>
      </div>
    </div>
    <div class="row mb-3">      
      <div class="col-md-3">
        <label class="form-label fw-bold">Result <span class="text-danger">*</span></label>
        <div class="dropdown-clear-wrapper activities-select-wrap">
          <select class="form-control" formControlName="result" required
            (change)="blurSelect($event)"
            [matTooltip]="getSelectLabel(editOosTestForm.get('result')?.value, oosResultOptions)"
            matTooltipPosition="above"
            matTooltipClass="custom-tooltip">
            <!-- <option value="">{{ placeholderMessage['P0130'] || 'Select Result' }}</option> -->
            <option *ngFor="let opt of oosResultOptions" [value]="opt.key">{{ opt.value }}</option>
          </select>
        </div>
        <div *ngIf="editOosTestForm.get('result')?.invalid && editOosTestForm.get('result')?.touched" class="text-danger small mt-1">
          {{ errorMessage['M0182'] || 'Result is required.' }}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4" (click)="onResetEditOosTestForm()">Reset</button>
    <button type="button" class="btn btn-primary btn-lg btnprimary" (click)="onSaveOosTestEdit()">Update</button>
  </div>
</ng-template>
